<template>
  <div class="top-bg">
    <video autoplay loop muted>
      <source src="/assets/img/cover.mp4" type="video/mp4">
    </video>
  </div>

  <div class="top-navs flex items-center justify-center">
    <!--      <label>来电咨询</label>-->
    <!--      <div class="flex items-center gap-[8px] font-num">0577-88919606<small>(总线)</small></div>-->
    <!--      <div class="mx-[20px] text-[14px] opacity-40">/</div>-->
    <!--      <div class="flex items-center gap-[8px] font-num">13587981867<small>(销售)</small></div>-->

    <ul class="flex gap-[50px]">
      <li
        v-for="(item, index) in menus"
        :key="index"
        class="text-[20px]"
      >{{ item.label }}</li>
    </ul>
  </div>

  <div class="greeting-info">
    <div class="greeting-info__left">
      <img src="/assets/img/word1.png" />

      <ul class="greeting-info__stats">
        <li
          v-for="(item, index) in stats"
          :key="index"
        >
          <h3>{{ item.title }}</h3>
          <p>{{ item.subtitle }}</p>
        </li>
      </ul>
    </div>

<!--    <div class="greeting-info__right">-->
<!--      <ul>-->
<!--        <li-->
<!--          v-for="(item, index) in prodList"-->
<!--          :key="index"-->
<!--          @click="handleJump(index)"-->
<!--        >-->
<!--          <div class="relative flex-1 flex flex-col justify-between">-->
<!--            <h1>{{ item.title }}</h1>-->
<!--            <h2>{{ item.subTitle }}</h2>-->
<!--            <p-->
<!--              v-if="index === 0"-->
<!--              class="mt-[20px] font-bold text-sm"-->
<!--              style="color: #f54a4a; letter-spacing: 2px"-->
<!--            >🔥 全新 FC-1506 系列已上线!</p>-->

<!--            <SvgIcon-->
<!--              v-if="index === 0"-->
<!--              name="cut"-->
<!--              class="absolute top-[6px] right-0 opacity-30"-->
<!--              :size="40"-->
<!--            />-->
<!--          </div>-->

<!--          &lt;!&ndash;          <img :src="`/assets/img/machine/${index + 1}.png`" alt="" />&ndash;&gt;-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->
  </div>
</template>

<script setup lang="ts">
  import stats from '@/assets/stats.json'
  import menus from '@/assets/menu.json'

  const router = useRouter()
  const prodList = [
    {
      title: '智能裁切',
      subTitle: 'Smart Cutting Experience',
      desc: '这是一段介绍此类产品的话语，可自行填入相对应的描述',
      // path: '/machine?cat=leatherCutting'
      path: ''
    },
    {
      title: '数控放版',
      subTitle: 'Automatic Grading',
      desc: '这是一段介绍此类产品的话语，可自行填入相对应的描述',
      // path: '/machine?cat=grading'
      path: ''
    },
    {
      title: '鞋样设计CAD',
      subTitle: 'CAD Software',
      desc: '这是一段介绍此类产品的话语，可自行填入相对应的描述',
      path: '/cad'
    }
  ]

  function handleJump(index: number) {
    router.push(prodList[index].path)
  }

</script>

<style scoped lang="scss">
  .top-bg {
    position: absolute;
    top: 0;
    left: 0;
    z-index: -4;
    width: 100%;
    height: 100vh;
    //background: #0046E4;
    background-color: #000;

    video {
      filter: brightness(50%);
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    label {
      border-radius: 50px;
      margin-top: 4px;
      margin-right: 20px;
      padding: 0 20px;
      height: 34px;
      line-height: 34px;
      font-size: 16px;
      color: #fff;
      background-color: #0046E4;
    }

    small {
      opacity: .6;
    }
  }

  .top-navs {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 100px;
    line-height: 100px;
    text-align: center;
    font-size: 28px;
    color: #fff;
    background-color: rgba(0, 0, 0, .9);

    li {
      cursor: pointer;
      opacity: .6;

      &:hover {
        color: #EF8D40;
        opacity: 1;
      }
    }
  }

  .greeting-info {
    display: flex;
    align-items: center;
    gap: 30px;
    padding: 0 180px;
    //height: calc(100vh - 180px);
    height: 100vh;
    color: #fff;

    &__left {
      width: 48vw;

      h1 {
        font-family: 'SourceHanSans-Bold', sans-serif;
        font-size: 58px;
      }

      & > button {
        display: flex;
        align-items: center;
        gap: 10px;
        border-radius: 50px;
        padding: 0 40px;
        height: 80px;
        font-size: 24px;
        color: rgba(255, 255, 255, .8);
        background-color: rgba(0, 0, 0, .6);

        span {
          margin-top: -4px;
        }
      }
    }

    &__right {
      flex: 1;

      ul {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-template-rows: repeat(2, 1fr);
        gap: 16px;

        li {
          display: flex;
          //flex-direction: column;
          border-radius: 16px;
          padding: 30px 40px;
          background-color: rgba(216, 216, 216, .1);
          transition: all ease-in-out .3s;
          opacity: .8;
          cursor: pointer;

          h1 {
            //font-size: 24px;
            font-family: "Yuanti SC", sans-serif;
            font-size: 20px;
            font-weight: 600;
            color: #a2a2a6;
          }

          h2 {
            //font-size: 18px;
            opacity: .3;
          }

          img {
            height: 140px;
          }

          &:first-child {
            grid-area: 1 / 1 / 2 / 3;

          }

          &:nth-child(2) {
            grid-area: 2 / 1 / 3 / 2;
            flex-direction: column;
          }

          &:last-child {
            grid-area: 2 / 2 / 3 / 3;
            flex-direction: column;
          }

          &:hover {
            opacity: 1;
            background-color: rgba(216, 216, 216, .2);

            h1 {
              color: #eee;
            }
          }
        }
      }
    }

    &__stats {
      display: flex;
      gap: 40px;
      margin: 40px 0 60px;

      li {
        h3 {
          font-family: 'Montserrat-Bold', sans-serif;
          font-size: 32px;
          font-weight: 600;
          color: #EF8D40;
          text-shadow: 0 4px 8px rgba(0, 0, 0, .8);
        }

        p {
          opacity: .4;
        }
      }
    }
  }
</style>
